import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  ref: "material"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle !text-3xl text-h-warning-400" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = ["initial", "enter"]
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col sm:flex-row w-full min-w-[360px] justify-start sm:justify-between items-start sm:items-center sticky top-0 p-3 bg-[#f8f9fa] rounded-sm gap-3 z-50"
}
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = { class: "flex items-center gap-5 w-fit" }
const _hoisted_10 = {
  key: 0,
  id: "tips",
  class: "group w-fit flex !justify-start lg:!justify-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 !text-xl rounded-full hover:scale-75 transition-all animate-bounce-short" }, null, -1)
const _hoisted_12 = { class: "hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg !z-50 shadow-md border overflow-hidden break-words whitespace-normal" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  class: /*#__PURE__*/_normalizeClass([
                'w-full  flex justify-end items-center gap-5 z-50 sm:w-[50%]',
              ])
}
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 2,
  id: "empty",
  class: "h-[80vh]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SkipVideo = _resolveComponent("SkipVideo")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_CourseLearningMapStudent = _resolveComponent("CourseLearningMapStudent")!
  const _component_HistoryMaterials = _resolveComponent("HistoryMaterials")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_Transcripts = _resolveComponent("Transcripts")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PDFComponent = _resolveComponent("PDFComponent")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.loaderStore.load[5])
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          loader: _ctx.loaderStore.load[5]
        }, null, 8, ["loader"]))
      : (_ctx.currentMaterial?.file)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.materialStore.skipVideoModal)
              ? (_openBlock(), _createBlock(_component_SkipVideo, {
                  key: 0,
                  skipModal: _ctx.materialStore.skipVideoModal,
                  onOnSkipVideo: _ctx.materialStore.onSkipVideo
                }, null, 8, ["skipModal", "onOnSkipVideo"]))
              : _createCommentVNode("", true),
            (_ctx.materialStore.isVideo)
              ? (_openBlock(), _createBlock(_component_Dialog, {
                  key: 1,
                  visible: _ctx.showAlert,
                  "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAlert) = $event)),
                  draggable: false,
                  breakpoints: { '960px': '95vw', '640px': '95vw' },
                  style: { width: '25vw', minWidth: '360px' },
                  modal: ""
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("section", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: `Alerta`, en: `Alert` })), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      class: "text-xl",
                      innerHTML: 
            'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
          
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["visible"]))
              : _createCommentVNode("", true),
            (_ctx.materialStore.showMap)
              ? (_openBlock(), _createBlock(_component_CourseLearningMapStudent, {
                  key: 2,
                  onOnCloseMap: _ctx.materialStore.setShowMap
                }, null, 8, ["onOnCloseMap"]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_5, [
              (
            _ctx.currentMaterial?.file?.url &&
            _ctx.materialStore.materials[0]?.file.status === 'DONE'
          )
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "px-3 mt-4 flex items-center flex-col w-full",
                    initial: _ctx.initialMotion,
                    enter: _ctx.enterMotion
                  }, [
                    (_ctx.typeModalHeader === 'STUDENT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.currentMaterial?.name), 1)
                            ]),
                            (_ctx.materialStore.isVideo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("p", { innerHTML: 
                      'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                     }, null, 8, _hoisted_13)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.currentMaterial)
                              ? (_openBlock(), _createBlock(_component_HistoryMaterials, {
                                  key: 0,
                                  materials: _ctx.materialStore.materials,
                                  currentMaterial: _ctx.currentMaterial,
                                  learningObjective: _ctx.learningObjectiveStore.learningObjective,
                                  isAdaptativeLearning: true,
                                  onOnChooseMaterial: _cache[1] || (_cache[1] = (e) => _ctx.materialStore.onChooseMaterial(e)),
                                  onOnCloseStudentMap: _ctx.materialStore.setShowMap
                                }, null, 8, ["materials", "currentMaterial", "learningObjective", "onOnCloseStudentMap"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_Button, {
                                class: "btn-primary p-button-sm",
                                disabled: _ctx.isDisabledBackButton,
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onGoBack()), ["prevent"])),
                                icon: "pi pi-chevron-left",
                                title: "`Voltar objeto de aprendizagem`"
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_Button, {
                                class: "btn-primary p-button-sm",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onGoNext()), ["prevent"])),
                                icon: "pi pi-chevron-right",
                                title: "`Próximo objeto de aprendizagem`",
                                disabled: _ctx.isDisableNextButton
                              }, null, 8, ["disabled"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.materialStore?.isVideo)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(`${_ctx.flex} mt-4 flex-col z-10`)
                        }, [
                          (_openBlock(), _createBlock(_component_VideoComponent, {
                            data: _ctx.currentMaterial?.file,
                            idVideo: _ctx.currentMaterial?.file.id,
                            startTime: _ctx.time,
                            isAdaptativeLearning: true,
                            ref: "videoComponent",
                            key: _ctx.currentMaterial?.file?.id
                          }, null, 8, ["data", "idVideo", "startTime"])),
                          _createVNode(_component_Transcripts, {
                            material: _ctx.currentMaterial,
                            onOnNeedsToPause: _ctx.needsToPause,
                            onOnClickDuration: _ctx.onSelectTranscriptionTime
                          }, null, 8, ["material", "onOnNeedsToPause", "onOnClickDuration"])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.materialStore?.isImage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(`${_ctx.flex} mt-4`)
                        }, [
                          (_openBlock(), _createBlock(_component_Image, {
                            src: _ctx.currentMaterial?.file.url,
                            alt: "material-image",
                            imageClass: "w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover",
                            preview: "",
                            key: _ctx.currentMaterial?.file?.id
                          }, null, 8, ["src"]))
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.materialStore?.isAudio)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: _normalizeClass(`${_ctx.flex} mt-4`)
                        }, [
                          (_openBlock(), _createElementBlock("audio", {
                            id: "material-audio",
                            src: _ctx.currentMaterial.file.url,
                            class: "w-full h-[100%] sm:h-[600px] lg:h-[600px]",
                            key: _ctx.currentMaterial?.file?.id
                          }, null, 8, _hoisted_16))
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.materialStore?.isPdf)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: _normalizeClass(`${_ctx.flex} mt-4`)
                        }, [
                          (_openBlock(), _createBlock(_component_PDFComponent, {
                            url: _ctx.currentMaterial?.file.url,
                            key: _ctx.currentMaterial?.file?.id
                          }, null, 8, ["url"]))
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_6)), [
                    [_directive_motion]
                  ])
                : _createCommentVNode("", true)
            ])
          ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_EmptyData, {
              data: !_ctx.currentMaterial,
              title: `${_ctx.$t('studentCourse.empty.materialBeingWatch.title')}`,
              label: `${_ctx.$t('studentCourse.empty.materialBeingWatch.description')}`,
              image: 'empty-materials-watch.svg',
              imgSize: "h-40"
            }, null, 8, ["data", "title", "label", "image"])
          ]))
  ]))
}